import React from "react";
import Modal from "react-modal";
import PasswordForm from "../forms/PasswordForm";
import { useDispatch, useSelector } from "react-redux";
import { customerSelector } from "../selector";
import { toggleChangePasswordModel } from "../action";
import { changePassword } from "../thunk";

const PasswordFormModal = () => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => customerSelector(state));

  return (
    <Modal
      className="Modal__Bootstrap modal-dialog"
      closeTimeoutMS={150}
      isOpen={customer.phoneNumberChangeModel}
      contentLabel="Add_Account"
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <i
              className="fa fa-times"
              aria-hidden="true"
              onClick={() => dispatch(toggleChangePasswordModel())}
            ></i>
          </div>
          <div className="acct-modal-heading">Change Password</div>
          <div className="acct-modal-hr"></div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <PasswordForm
            closeChangePasswordModal={() =>
              dispatch(toggleChangePasswordModel())
            }
            resetPasswordAccount={(payload) =>
              dispatch(changePassword(payload.newPassword, payload.oldPassword))
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export { PasswordFormModal };
